import LoadingOverlay from "./LoadingOverlay";

export default LoadingOverlay;

